export default {
  greeting: {
    id: 'vanishing_deals_pickle_banner_greeting',
    defaultMessage: 'Hello,',
  },
  presentation: {
    id: 'vanishing_deals_pickle_banner_presentation',
    defaultMessage:
      'I’m Mister Pickles. I’m here to please you! I relentlessly go through our merchants stocks to curate the best deals we have.',
  },
  imageAlt: {
    id: 'vanishing_deals_pickle_banner_image_alt',
    defaultMessage: 'portrait of Mister Pickles smiling',
  },
}
